module.exports = __webpack_public_path__ + "static/JanhaviJain-27da193b607036e1b39cae080cd97dd5.jpg";